import esLocale from "element-ui/lib/locale/lang/es";
const es = {
  //西班牙语 Spanish
  login: {
    buttoo: {
      add: "新增",
    },
  },
  dialog: {
    buttton: {
      close: "Cerca",
    },
    ReportError: {
      next: "siguiente",
      h1: "Reportar errores permite a los usuarios comunicarse con nosotros para resolver cualquier problema de datos y mejorar la calidad de los datos.",
      li1: "Si encuentra algún problema con los datos o tiene alguna pregunta sobre estos datos",
      li2: "Si quieres aportar información de la empresa para mejorar estos datos",
      li3: "Si decide no revelar la información de su propia empresa que podría considerar privada",
      li4: "Si tiene alguna sugerencia constructiva para que mejoremos los servicios",
      h2: "Todos los comentarios enviados están sujetos a verificación de datos. Los usuarios deben completar su propio perfil de usuario, ya que nuestro representante puede comunicarse con usted para autenticar y verificar los derechos de su empresa para representarla.",
      Iamanemployeeofthissubjectcompany: "Soy empleado de esta empresa",
      Reportmycompany: "Denunciar mi empresa",
      Updatedata: "Actualizar datos",
      Reportinformationerrors: "Informar errores de información",
      Reportotherscompany: "Denunciar a otras empresas",
      Financial: "Financiera",
      Pleaseprovidemoreinfo: "Por favor, proporcione más información.",
      Year: "Año",
      Business: "Negocio",
      Noofemployees: "No. de empleadas",
      Coremanagement: "Gestión central",
      Corebusinessactivites: "Actividades comerciales principales",
      IntBusiness: "Negocios internacionales",
      Pleasedescribeyouractivites: "Por favor, describa sus actividades.",
      Pleaselistcountriesyoudobusine:
        "Por favor, indique los países con los que realiza negocios.",
      Corecompetency: "Competencia básica",
      Businessoutlook: "Perspectivas empresariales",
      Uploadfiles: "Subir archivos",
      Upload: "Subir",
      Cancel: "Cancelar",
      Submit: "Entregar",
      Select: "Seleccionar",
      Selectthedatacategoryyoureport:
        "Seleccione la categoría de datos que reporta",
      TotalCurrentAssets: "Activos corrientes totales",
      CashBank: "Efectivo y banco",
      Accountreceivable: "Cuentas por cobrar",
      AdvancestoSuppliers: "Anticipos a proveedores",
      Inventory: "Inventario",
      Tobeappointedexpense: "A ser designado gasto",
      Totalnoncurrentassets: "Activos no corrientes totales",
      Longterminvestment: "Inversión a largo plazo",
      Fixedassetsnetvalue: "Valor neto de los activos fijos",
      Projectsunderconstruction: "Proyectos en construcción",
      Longtermtobeappointedexpenise: "Gastos de nombramiento a largo plazo",
      Deferredtaxdebit: "Débito por impuesto diferido",
      Totalcurrentliabilities: "Pasivos corrientes totales",
      Accountpayable: "Cuentas por pagar",
      Advancesfromclients: "Anticipos de clientes",
      Salariespayable: "Sueldos a pagar",
      Taxespayable: "Impuestos a pagar",
      Otheraccountspayable: "Otras cuentas por pagar",
      Totalequity: "Patrimonio total",
      Paidupcapital: "Capital desembolsado",
      Capitalreserves: "Reservas de capital",
      Surplusreserves: "Reservas excedentes",
      Undistrbutedporfit: "Beneficio no distribuido",
      Totalassets: "Activos totales",
      Turnover: "Volumen de negocios",
      Costofgoodssold: "Costo de los bienes vendidos",
      Salestax: "Impuesto sobre las ventas",
      Grossprofit: "Beneficio bruto",
      Otheroperatingprofils: "Otros perfiles operativos",
      Salesexpense: "Gastos de ventas",
      Managementexpense: "Gastos de gestión",
      Financeexpense: "Gastos financieros",
      Operatingprofit: "Beneficio operativo",
      Nonoperatingincome: "Ingresos no operativos",
      Profitbeforetax: "Beneficio antes de impuestos",
      Incometax: "Impuesto sobre la renta",
      Netincome: "Lngresos netos",
      DataProblems: "Problemas de datos",
      CorrectInformation: "Información correcta",
    },
  },
  Home: {
    Applications: "Aplicaciones",
    SearchCompanies: "Buscar empresas",
    SearchLeads: "Búsqueda de clientes potenciales",
    SearchTrade: "Buscar comercio",
    SearchSanctions: "Buscar sanciones",
    SearchNews: "Buscar noticias",
    RiskScan: "Escaneo de riesgos",
    SearchRelationship: "Relación de búsqueda",
    DataServices: "Servicios de datos",
    SearchCountries: "Buscar países",
    selectCountry: "Seleccionar país",
    Entercompanyname: "Ingresar nombre de la empresa",
    keWord: "Palabra clave", //关键词
    firstWord: "Exactamente a la izquierda", //首词
    search: "Buscar", //搜索
    homeSeachTitle: "Enfoque en los negocios globales", //聚焦全球商情
    homeTitleDetail:
      "CSI, una firma de investigación y TI basada en datos, se especializa en crédito, riesgo y big data. Ofrece herramientas digitales a inversores y profesionales de negocios globales, aprovechando análisis y algoritmos avanzados para brindar información visual y rápida que facilita una toma de decisiones más inteligente.",
    phoneTitleDetail:
      "Para buscar, ver y obtener información de la empresa rápidamente, también puede usar la aplicación de CSI en su teléfono.", //您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。,
    searchCompanyNum:
      "Busque más de 500 millones de empresas en más de 200 países y territorios",
    newsHeadTitle:
      "Descubre las ideas estratégicas que se esconden tras cada titular de empresa.",
    sanctionHeadTitle:
      "Navegue por el comercio internacional con confianza examinando a las empresas y los productos en función de las sanciones globales.",
    tradeHeadTitle:
      "Transforma los datos del comercio mundial en información estratégica de mercado.",
    relationshipTitle:
      "Máxima propiedad y control / Huella de inversión / Red de cadena de suministro / Cumplimiento normativo optimizado / Mitigación de riesgos / Cobertura global",
    IndustryAnalysis: "Análisis de la industria",
    BusinessAnalytics: "Análisis empresarial",
    ImportExportData: "Importar-Exportar Datos",
    CompanyNews: "Noticias de la empresa",
    Sanctions: "Sanciones",
    BusinessIntelligence: "Inteligencia de Negocios",
    CompanyIdentityVerification: "Verificación de identidad de la empresa",
    KYCSolutions: "Soluciones KYC",
    OwnershipPenetration: "Penetración de propiedad",
    CompanyFinancialAnalysis: "Análisis financiero de la empresa",
    CreditRatings: "Calificaciones crediticias",
    CreditReports: "Informes de crédito",
    ESGRatings: "Calificaciones ESG",
    VendorScreening: "Selección de proveedores",
    MarketResearch: "Investigación de mercado",
    EnterKeyword: "Introduzca la palabra clave",
    Country: "País",
    Company: "Empresa",
    Person: "Persona",
    Product: "Producto",
    EnterPersonName: "Ingrese el nombre de la persona",
    EnterCountryName: "Ingrese el nombre del país",
    EnterproductName: "Introduzca las palabras clave del producto",
    EnterproductNamekeywordsorHSCode:
      "Introduzca palabras clave del producto o código HS",
    Searchby: "Buscar por",
    SICStandardIndustryCode: "SIC - Código Industrial Estándar",
    HSCodeHarmonizedSystemCode: "Código HS - Código del Sistema Armonizado",
    AIAssistance: "Asistencia de IA",
    EnterISICNACENAICSCSICAAAICGICS:
      "Ingrese CIIU / NACE / NAICS / CSIC / AAAIC / GICS",
    EnterHarmonizedSystemCode: "Introduzca el código del sistema armonizado",
    SIC: "SIC",
    HSCode: "HSCode",
    Tips: "Consejos",
    detailconttext:
      "La función a la que intentas acceder forma parte de los beneficios de nuestra membresía premium. Para acceder a esta función y disfrutar de todas las ventajas premium, suscríbete a nuestro plan de membresía.",
    Subscribe: "Suscribir",
  },
  Toolbar: {
    Filter: "Filtrar",
    Select: "Seleccionar",
    Edit: "Editar",
    Sortby: "Ordenar por",
    Collect: "Recopilar",
    Saved: "Guardados",
    Compare: "Comparar",
    Export: "Exportar",
    Download: "Descargar",
    Update: "Actualizar",
    Reporterror: "Informar de un error",
    Share: "Compartir",
    ascending: "ascendiendo",
    descending: "descendiendo",
    Yourfolder: "Tu carpeta",
    RiskScanning: "Análisis de riesgos",
    CreditAssessment: "Evaluación crediticia",
    DataAnalysis: "Análisis de datos",
    NewPortfolio: "Nueva cartera",
    Print: "Imprimir",
    Optimize: "Optimizar",
    ALL: "Todos",
    Confirm: "Confirmar",
  },
  Export: {
    Choosethedatafields: "Seleccione los campos de datos que desea exportar.",
    Enterkeywords: "Introduzca la palabra clave",
    Financialdata: "Datos financieros",
    Reset: "Reiniciar",
    Back: "Atrás",
    Howmanyresults:
      "Cuántos resultados desea exportar de esta búsqueda? También puede refinar su búsqueda agregando filtros adicionales.",
    FileName: "Nombre del archivo",
    Pleaseenterafilename: "Por favor, introduzca un nombre de archivo",
    SelectedList: "Lista seleccionada",
  },
  AiZaba: {
    whatareyousearchingfor: "Qué estás buscando?",
    CreditAnalyst: "Analista de crédito",
    Assesses:
      "Evalúa la solvencia crediticia de una empresa, identifica riesgos financieros y garantiza transacciones seguras a través del análisis de datos y calificaciones crediticias.",
    LegalAdvisor: "Asesor Jurídico",
    Provides:
      "Proporciona orientación sobre cumplimiento, revisa contratos y evalúa riesgos legales para garantizar que las operaciones comerciales se alineen con las leyes y eviten disputas.",
    BizConsultant: "Consultor de negocios",
    Optimizes:
      "Optimiza las cadenas de suministro, identifica compradores e impulsa las ventas analizando las tendencias del mercado y ofreciendo estrategias personalizadas para mejorar la eficiencia.",
    EconomicAnalyst: "Analista Económico",
    Analyzes:
      "Analiza la industria y las tendencias económicas regionales, ayudando Las empresas toman decisiones informadas y se mantienen competitivas.",
    HiImZabaYourresearchassistant:
      "Hola, soy Zaba, tu asistente de investigación",
  },
  navigationBar: {
    Notifications: "Notificaciones", //通知
    MarkasRead: "Marcar como leído", //标记已读
    Viewall: "Ver todo", //查看全部
    SilverSubscriber: "Suscriptor Plata", //银级用户
    GoldSubscriber: "Suscriptor Oro", //金级用户
    SubscriptionExpires: "La suscripción caduca",
    AvailableCredits: "Créditos disponibles", //可用积分
    AddCredits: "Añadir créditos", //购买积分
    IndivdualAccount: "Cuenta individual", //个人账号
    GroupAccount: "Cuenta de grupo", //集团账号
    UserAccount: "Cuenta de usuario",
    Roles: "Roles", //角色
    Thereiscurrentlynonewnews: "Actualmente no hay noticias nuevas",
    EnterTitleContent: "Introduzca el contenido del título",
  },
  ListofResults: {
    Country: "País",
    Industry: "Sector",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamaño de la empresa",
    CompanyStatus: "Estado de la empresa",
    CompanyName: "Nombre de la empresa",
    RegStatus: "Estado de registro",
    StateProvince: "Estado/Provincia",
    CityCounty: "Ciudad/Condado",
    DistrictCity: "Distrito/Ciudad",
    IncDate: "Fecha de constitución",
    LegalForm: "Forma jurídica",
    CoID: "ID de la empresa",
    TaxNo: "N.º de identificación fiscal",
    ListingInfo: "Información del listado",
    Phone: "Teléfono",
    Website: "Sitio web",
    Email: "Correo electrónico",
    LegalPerson: "Persona jurídica",
    PostCode: "Código postal",
    ISIC: "ISIC",
    IndustryDescription: "IDescripción del sector",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Calificación crediticia",
    SolvencyIndex: "Índice de solvencia",
    ProbabilityofDefault: "Probabilidad de impago",
    NoofEmployees: "N.º de empleados",
    Revenue: "Ingresos",
    TotalAsset: "Activo total",
    NetProfit: "Beneficio neto",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mostrar más",
    SelectCountry: "Seleccionar país",
    ClearAll: "Borrar todo",
    SelectIndustry: "Seleccionar industria",
    ListedCompany: "Empresa cotizada",
    YearsinBusiness: "Años en el negocio",
    Sharethisinformation: "Comparte esta información",
    Pleaseaddress:
      "Por favor ingrese una o más direcciones de correo electrónico",
    Example: "Ejemplo",
    message: "mensaje",
    pleaseleaveamessage: "por favor deja un mensaje",
    Include: "incluir",
    thisaddress: "nombre de esta empresa, ID, dirección",
    CSIwebsite: "sitio web del CSI",
    Update: "Actualizar",
    Iftheavailable:
      'Si los datos disponibles en línea son insuficientes o están desactualizados, puede hacer clic en el botón "Actualizar" para solicitar una actualización instantánea de un nuevo informe crediticio comercial investigado por parte de nuestros investigadores de redes locales o agencias de informes crediticios. El costo de esta actualización es de 1 crédito por empresa. El informe de actualización suele tardar entre 24 y 72 horas en entregarse.',
    Abusinesscredit:
      "Un informe de crédito comercial proporciona información detallada sobre los datos de identificación de la empresa en cuestión, registros de registro, estructura accionaria, historial de la empresa, descripción de la administración, empresas relacionadas, operaciones reales, referencias comerciales, datos y análisis financieros, información pública oficial, como registros de litigios y sanciones, y análisis y evaluación de crédito.",
    Searchcompanies: "Buscar más correos electrónicos de otras empresas",
    Rowsperpage: "Filas por página",
    Remove: "Quitar",
    Confirm: "Confirmar",
  },
  ContentTabs: {
    Background: "Antecedentes",
    BusinessActivities: "Actividades comerciales",
    Performance: "Rendimiento",
    Publications: "Publicaciones",
    CreditOpinion: "Opinión crediticia",
    MarketAnalysis: "Análisis de mercado",
    Snapshot: "Panorama general",
    Profile: "Perfil",
    Ownership: "Propiedad",
    RelatedCompanies: "Empresas relacionadas",
    Management: "Administración",
    Operations: "Operaciones",
    Locations: "Ubicaciones",
    Industry: "Sector",
    ImportExport: "Importación y exportación",
    SupplyChain: "Cadena de suministro",
    FinancialHighlights: "Información financiera destacada",
    RatioAnalysis: "Análisis de ratios",
    IndustryNorm: "Norma del sector",
    News: "Noticias",
    Sanctions: "Sanciones",
    IndustryStatistics: "Estadísticas del sector",
    RatingAnalysis: "Análisis de calificación",
    CompetitiveAnalysis: "Análisis competitivo",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "El Índice de Calidad de Datos (DQI) emplea algoritmos para evaluar diferentes aspectos de los datos, incluida la integridad, la validez, la confiabilidad de las fuentes, la coherencia, la puntualidad y el soporte bilingüe.",
    CompanyDQIdesc2:
      "El índice está diseñado para evaluar la calidad de los datos en una escala del 1 al 100, donde las puntuaciones más altas indican una calidad superior de los datos. Los algoritmos pueden analizar datos basándose en reglas o criterios predefinidos, permitiendo mediciones objetivas y estandarizadas.",
    CompanyDQIdesc3:
      "Nuestro Índice de calidad de datos (DQI) sirve como un indicador confiable que permite a los usuarios evaluar cuantitativamente la calidad de los datos. Esto permite la toma de decisiones basada en datos y mejora el valor general y la utilidad de los datos.",
    CountryDQIdesc1:
      "El Índice de Calidad de Datos (DQI) evalúa la confiabilidad, precisión y accesibilidad de los datos entre países, lo que refleja diferencias en infraestructura digital, gobernanza y transparencia. Las naciones desarrolladas generalmente ocupan puestos más altos debido a sistemas de datos sólidos, políticas abiertas y tecnología avanzada, mientras que las economías en desarrollo a menudo luchan con brechas en infraestructura, regulación o prácticas de intercambio de datos.",
    CountryDQIdesc2:
      "Los factores clave incluyen la transparencia gubernamental, las leyes de protección de datos y la adopción tecnológica. Un DQI alto permite una mejor formulación de políticas y decisiones comerciales, mientras que un puntaje bajo resalta áreas que necesitan inversión.",
    CompanyDQI: "Empresa DQI", //公司数据质量指数 DQI
    CountryDQI: "DQI del país", //国家数据质量指数 DQI
    CompanyTitle: "Índice de calidad de datos (DQI) por empresa",
    CountryTitle: "Índice de calidad de los datos (DQI) por país",
    Address: "Dirección", //地址
    CountyCity: "Condado/Ciudad", //县/市
    ProvinceState: "Provincia/Estado", //省/州
    CountryRegion: "País/Región", //国家/地区
    ZipCode: "Código Postal", //邮政编码
    Website: "Sitio Web", //网站
    Email: "Correo Electrónico", //电邮
    Tel: "Teléfono", //电话
    LastUpdate: "Última Actualización", //最近更新
    DataSource: "Fuente de Datos", //数据来源
    LegalStatus: "Estatus Legal", //法定状况
    CoID: "ID de la Empresa", //公司ID
    CompanyType: "Tipo de Empresa", //公司类型
    RegistrationDate: "Fecha de Registro", //注册日期
    RegistrationStatus: "Estado de Registro", //注册状态
    Listed: "Cotizada", //上市信息
    CurrentOpperations: "Operaciones Actuales", //经营状况
    IndustryCode: "Código de Sector", //行业代码
    BusinessActivities: "Actividades Comerciales", //主营业务
    NoofEmployees: "N.° de Empleados", //员工数量
    NoofShareholders: "N.° de Accionistas", //股东数量
    Management: "Administración", //管理状况
    Performance: "Rendimiento", //业绩表现
    Revenue: "Ingresos", //收入
    Assets: "Activos", //资产
    ProfitLoss: "Ganancias/Pérdidas", //利润
    Growth: "Crecimiento", //公司增长
    Competitiveness: "Competitividad", //竞争力
    CreditOpinion: "Opinión Crediticia", //信用状况
    CreditRating: "Calificación Crediticia", //信用评级
    CreditScore: "Puntuación Crediticia", //信用评分
    ESGRating: "Calificación ESG", //ESG 评级
    Solvency: "Solvencia", //偿还能力
    Sanctions: "Sanciones", //全球制裁
    CoName: "Nombre de la empresa",
    RegName: "Nombre registrado",
  },
  Profile: {
    CompareCompanies: "Comparar empresas",
    AddaCompany: "Agregar una empresa",
    SubjectCompany: "Empresa en cuestión", //目标公司
    ComparisonCompany: "Empresa de comparación",
    CompanyProfile: "Perfil de la empresa", //基本资料
    CompanyName: "Nombre de la empresa", //公司名称
    NativeName: "Nombre de la empresa", //当地名称
    CompanyID: "ID de la empresa", //公司 ID
    VATNumber: "Número de IVA", //VAT号
    StockCode: "Código bursátil", //股票代码
    Listed: "Cotización", //上市日期
    RegistrationDate: "Fecha de registro", //注册日期
    LegalForm: "Forma jurídica", //公司性质
    CompanyType: "Tipo de empresa", //公司类型
    LegalStatus: "Estatuto jurídico", //注册状态
    Jurisdiction: "Jurisdicción", //司法管辖区
    RegisteredAddress: "Domicilio social", //注册地址
    ProvinceState: "Provincia/Estado", //省/州
    CountryRegion: "País/Región", //国家/地区
    ZipCode: "Código postal", //邮政编码
    OperatingAddress: "Dirección operativa", //经营地址
    LastUpdate: "Última actualización", //最近更新
    DataSource: "Fuente de datos", //数据来源
    History: "Historial", //历史记录
    RegisteredCapital: "Capital registrado",
    PaidinCapital: "Capital pagado",
    CountyCity: "Condado/Ciudad",
    OtherName: "Otro nombre",
  },
  Ownership: {
    TotalPartiesInvolved: "Total de partes involucradas",
    UltimateBeneficiaryOwner: "Beneficiario Final (UBO)", //最终受益人
    NaturalPersonShareholder: "Accionista Persona Física", //涉及自然人股东
    CorporateShareholders: "Accionistas corporativos", //涉及法人股东
    ShareholderLevel: "Nivel de accionista", //股东层级x
    Name: "Nombre", //名称
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Type: "Tipo", //类型
    Shares: "Acciones", //股份
    Relation: "Relación", //关系
    RelatedCompany: "Empresas relacionadas",
    CompanyShareholders: "Accionistas de la empresa",
    NGOShareholders: "Accionistas de ONG",
    SubjectInvestments: "Inversiones del sujeto",
  },
  RelatedCompanies: {
    Total: "Entidades totales", //相关公司总计
    Countries: "Países", //国家/地区
    Branches: "Sucursales", //分支机构
    RelatedComp: "Empresas relacionadas", //关联公司
    Name: "Nombre", //名称
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Type: "Tipo", //类型
    Relationship: "Relación", //关系
    BranchOffices: "Sucursales",
    Subsidiaries: "Filiales",
  },
  Management: {
    Management: "Direccion", //管理层
    ContactInfo: "Información de contacto", //联系人信息
    Countries: "Países", //国家/地区
    Name: "Nombre", //名称
    Position: "Puesto", //职位
    Department: "Departamento", //部门
    Country: "País", //国家/地区
    ShareholderNot: "Accionista o no", //是否股东
    Relation: "Relaciones", //关系
    Verification: "Verificación", //已验证
    Searchmoreemails: "Buscar más correos electrónicos", //搜索更多电邮
    Roles: "Roles", //角色
    EducationLevel: "Nivel educativo", //教育程度
    Phone: "Teléfono", //电话
    Email: "Correo electrónico", //电邮
    Verified: "Verificado", //已验证
    Searchmore: "Buscar más correos electrónicos de otras empresas", //搜索更多其他公司的电邮
    Pleaseentername: "Por favor ingrese el nombre",
    PleaseenterWebsite: "Introduzca el nombre de la empresa o el dominio.",
    UserSelfVerification: "Autoverificación del usuario",
    Userverified: "Usuario verificado",
    Source: "Origen",
  },
  Operations: {
    LineofBusiness: "Línea de negocio", //业务范围
    BusinessTerritories: "Territorios comerciales", //业务区域
    ImportExport: "Importación y exportación", //进出口信息
    Viewtradeinfo: "Ver más información comercial", //查看更多贸易信息
    ProductsServices: "Productos/Servicios", //产品/服务
    Products: "Productos", //产品
    ProductImage: "Imagen del producto", //产品图片
    ProductName: "Nombre del producto", //产品名称
    ProductDescription: "Descripción del producto", //产品描述
    Details: "Detalles", //详情
    Addproductinformation: "Añadir información del producto", //添加产品信息
    Showcaseyourcompany:
      "Si desea mostrar los productos o servicios de su empresa al público, puede agregar la información de su producto y servicio aquí. Esta es una excelente manera de promocionar su negocio. Una vez que hayamos revisado su envío, sus datos se publicarán.",
  },
  Locations: {
    CoName: "Nombre de la empresa", //业务范围
    Relationship: "Relación", //关系
    Type: "Tipo", //类型
    Country: "País", //国家/地区
    Location: "Ubicación", //地点
    Address: "Dirección", //地址
    Edit: "Editar", //编辑
    CompanyLocatiionsMap: "Ubicaciones de la empresa en el mapa", //地图中的公司位置
    Selectaddresstype: "Seleccionar tipo de dirección", //选择地址类型
    Subjectcompany: "Empresa objeto", //目标公司
    Subsidiary: "Filial", //子公司
    RegisteredAddress: "Domicilio social", //注册地址
    OperationAddress: "Dirección operativa", //运营地址
    All: "Todos", //全部
    Showlocation: "Mostrar ubicaciones",
  },
  Industry: {
    IndustryTitle: "Título de la industria", //IndustryTitle
    IndustryDescription: "Descripción de la industria", //IndustryDescription
    ISIC: "CIIU", //ISIC
    ISICDescription: "Descripción CIIU", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Descripción NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Descripción NAICS", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Descripción CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Descripción AAAIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Descripción GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Importe total de importación", //进口总额
    TopImportCountry: "Principales países de importación", //最大进口国家/地区
    TopImportProduct: "Principales productos de importación", //最大进口产品
    TotalExport: "Monto total de las exportaciones", //出口总额
    TopExportCountry: "Principales países de exportación", //最大出口国家/地区
    TopExportProduct: "Principales productos de exportación", //最大出口产品
    TradeVolume: "Volumen comercial", //贸易额
    ImportShipments: "Envíos de importación", //进口量
    ExportShipments: "Envíos de exportación", //出口量
    ImportCountries: "Países de importación", //进口国家/地区
    ExportCountries: "Países de exportación", //出口国家/地区
    ImportVolume: "Volumen de importación", //进口量
    ExportVolume: "Volumen de exportación", //出口量
    Suppliers: "Principales proveedores", //主要供应商
    Shipments: "Por número de envíos", //按出货量
    Buyers: "Principales compradores", //主要买家
    ImportQuantity: "Cantidad de importación", //进口数量
    IncreaseDecreasexRate: "Tasa de aumento/disminución", //增/减率
    ExportQuantity: "Cantidad de importación", //出口数量
    ImportsExportsRecords: "Registros de importaciones y exportaciones", //进出口记录
    Date: "Fecha", //日期
    Product: "Producto", //产品
    HSCode: "Código SA", //HS 编码
    BuyerName: "Nombre del comprador", //买家名称
    Destination: "Destino", //目的地
    SupplierName: "Nombre del proveedor", //供应商名称
    Origin: "Origen", //原产地
    Amount: "Monto (USD)", //金额
    Details: "Detalles", //详情
    Imports: "Importaciones",
    Exports: "Exportaciones",
    Shipments2: "Envíos",
    value2: "valor",
    value: "Por número de valor",
    viewmoretradeinfo: "ver más información comercial",
    SearchHSCode: "Buscar código HS",
    Selectdate: "Seleccione la fecha",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "Este gráfico ilustra las relaciones de “comprar a” y “vender a” de la empresa en cuestión. Cuanto mayor sea el volumen, más grueso será el tubo.",
  },
  ShippingOrderDetails: {
    Date: "Fecha",
    MasterBillofLading: "Conocimiento de Embarque Maestro",
    Source: "Origen",
    BillNo: "N.° de conocimiento",
    ImporterBuyer: "Importador/Comprador",
    ExporterSeller: "Exportador/Vendedor",
    Name: "Nombre",
    Address: "Dirección",
    Country: "País",
    Contact: "Contacto",
    Email: "Correo electrónico",
    CargoInfo: "Información de la carga",
    HSCode: "Código SA",
    Quantity: "Cantidad",
    WeightUnit: "Unidad de peso",
    ProductDescription: "Descripción del producto",
    Amount: "Monto (USD)",
    QuantityUnit: "Unidad de cantidad",
    Weight: "Peso",
    HSDescription: "Descripción SA",
    Incoterms: "Incoterms",
    ShippingInfo: "Información de envío",
    Vessel: "Buque",
    Consignee: "Destinatario",
    MeansofTransport: "Medio de transporte",
    CountryofOrigin: "País de origen",
    Voyage: "Viaje",
    Notifier: "Notificador",
    CountryofDestnation: "País de destino",
    AddressofOrigin: "Dirección de origen",
    Shipper: "Expediente",
    AddressofDestnation: "Dirección de destino",
    Container: "Contenedor",
    ContainerID: "ID del contenedor",
    ContainerType: "Tipo de contenedor",
    ContainerDescDode: "Dirección de descripción del contenedor",
    ContainerSize: "Tamaño del contenedor",
    ImportExport: "Importador / Exportador",
    Imports: "Importaciones",
    Exports: "Exportaciones",
  },
  FinancialHighlight: {
    Revenue: "Ingresos", //收入
    Profit: "Beneficios", //利润
    Growth: "Crecimiento", //增长
    CashFlowStatus: "Estado del flujo de caja", //现金流状况
    FinancialStructure: "Estructura financiera", //融资结构
    CreditOpinion: "Opinión crediticia", //信用评估
    RiskIndicator: "Indicador de riesgo", //风险指标
    Solvencyindex: "Índice de solvencia", //偿还指数
    Year: "Año", //年份
    Change: "Cambio", //变化
    NetProfit: "Beneficio neto",
    TotalAssets: "Activos totales",
    Equity: "Patrimonio neto",
    GrossMargin: "Margen bruto",
    ProfitMargin: "Margen de beneficio",
    ReturnonEquity: "Rentabilidad del capital propio",
    CurrentRatio: "Ratio de liquidez",
    DebtRatio: "Ratio de endeudamiento",
    FinancialHighlights: "Datos financieros de las empresas vinculadas", //关联公司财务数据
    FinancialHighlightsTitle:
      "Información financiera destacada de las empresas vinculadas", //关联公司财务摘要
    CompanyName: "Nombre de la empresa", //公司名称
    CompanyID: "ID de la empresa", //公司ID
    Country: "País", //国家/地区
    CompanyStatus: "Estado de la empresa", //公司状态
    Cancel: "Cancelar", //取消
    Select: "Seleccionar",
    Relations: "Relaciones", //关系
    Financialperformancedata:
      "Los datos sobre el desempeño financiero se recopilan de diversas fuentes gubernamentales y agencias de informes crediticios locales. Además, se utiliza investigación de mercado e industria para calcular y modelar los datos. Para obtener información más detallada sobre las operaciones reales y el análisis de desempeño, comuníquese con nuestro equipo de servicio para solicitar un informe de diligencia debida de la empresa.",
    Whenthesubjectsdata:
      "Cuando los datos del sujeto son insuficientes, o está interesado en obtener más información sobre su cliente, esta plataforma ofrece una vista integral de todas las entidades relacionadas con el tema. Esto incluye los accionistas de la empresa del sujeto, las empresas relacionadas y más.",
    Byprovidingyou:
      "Al brindarle una perspectiva más amplia, esta plataforma le permite realizar evaluaciones más informadas y obtener una comprensión más profunda de su tema.",
    PleaseSelectTheYeartoDisplay: "Seleccione el año para mostrar",
    SelectUptoThreeYears: "Seleccione hasta tres años",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Índices de rentabilidad",
    Year: "Año", //年份
    Change: "Cambio", //变化
    Returnonequity: "Rentabilidad del capital",
    Returnonassets: "Rentabilidad de los activos",
    Profitmargin: "Margen de beneficio",
    Grossmargin: "Margen bruto",
    OperatingRatios: "Índices operativos",
    Assetsturnover: "Rotación de activos",
    Stockturnover: "Rotación de existencias",
    Salesperiod: "Periodo de ventas",
    Collectionperiod: "Periodo de cobro",
    Creditperiod: "Periodo de crédito",
    StructuralRatios: "Índices de estructura",
    Currentratio: "Ratio de liquidez",
    Quickratio: "ratio de liquidez inmediata",
    Shareholdersliquidityratio: "Ratio de liquidez de los accionistas",
    Solvencyratio: "Ratio de solvencia",
    Debtratio: "Ratio de endeudamiento",
    ProductivityRatios: "Índices de productividad",
    Profitperemployee: "Beneficio por empleado",
    Operatingrevenueperemployee: "Ingresos operativos por empleado",
    Shareholdersfundsperemployee: "Fondos propios por empleado",
    Totalassetsperemployee: "Activos totales por empleado",
    GrowthRatios: "Índices de crecimiento",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
    FinancialHighlights: "Datos financieros de las empresas vinculadas", //关联公司财务数据
    RatioAnalysis: "Análisis de índices de las empresas vinculadas", //关联公司比率分析
    CompanyName: "Nombre de la empresa",
    CompanyID: "ID de la empresa",
    Country: "País",
    CompanyStatus: "Estado de la empresa",
    Relations: "Relaciones",
  },
  IndustryNorms: {
    IndustryStatistics: "Estadísticas del sector",
    ofcompaniesintheIndustry: "N.° de empresas del sector",
    oflistedCompaniesintheIndustry:
      "N.° de empresas que cotizan en bolsa en el sector",
    oflargecompaniesintheIndustry: "N.° de grandes empresas del sector",
    ofSMEsintheIndustry: "N.° de pymes del sector",
    ofcompaniesinsample: "N.° de empresas de la muestra",
    ofcompaniesinloss: "N.° de empresas con pérdidas",
    Observations: "Observaciones",
    AverageValue: "Valor medio",
    MedianValue: "Valor medio",
    MaximumValue10: "Valor máximo 10%",
    MinimumValue10: "Valor mínimo 10%",
    SubjectCompany: "Empresa en cuestión",
    YearsinBusiness: "Años en el mercado",
    TotalAssets: "Activos totales",
    TotalEquity: "Patrimonio neto total",
    Revenue: "Ingresos",
    NetEarning: "Beneficio neto",
    Returnonassets: "Rentabilidad de los activos",
    Performance: "Rendimiento",
    ProfitabilityRatios: "Ratios de rentabilidad",
    Returnonequity: "Rentabilidad del patrimonio neto",
    Grossmargin: "Margen bruto",
    OperatingRatios: "Ratios operativos",
    Stockturnover: "Rotación de existencias",
    Accountsreceivableturnover: "Rotación de cuentas por cobrar",
    Assetsturnover: "Rotación de activos",
    Totalassetturnover: "Rotación de activos totales",
    StructuralRatios: "Ratios de estructura",
    Currentratio: "Ratio de liquidez",
    Quickratio: "ratio de liquidez inmediata",
    Shareholdersliquidityratio: "Ratio de liquidez de los accionistas",
    GrowthRatios: "Ratios de crecimiento",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
  },
  Lawsutis: {
    Litigations: "litigios",
    Date: "Fecha",
    CaseType: "Tipo de caso",
    Title: "Título del caso",
    CaseNo: "Caso No.",
    CauseofAction: "Causa de acción",
  },
  News: {
    Date: "Fecha", //日期
    Title: "Título", //标题
    Source: "Fuente", //来源
    Impact: "Impacto", //影响
    Searchcompanies: "Buscar más noticias sobre otras empresas", //国家/地区
    SearchforTitle: "Buscar título",
    CompanyName: "Nombre de la empresa",
    Industry: "Industria",
    Subjects: "Materias",
    NewsTypes: "Tipos de noticias",
    ByDate: "Por fecha",
    SelectCompanyName: "Seleccione el nombre de la empresa",
    SelectIndustry: "Seleccionar industria",
    SelectSubjects: "Seleccionar asignaturas",
    SelectNewsType: "Seleccione el tipo de noticia",
    Negative: "Negativa",
    Positive: "Positiva",
  },
  Sanctions: {
    Potentialcompliance: "Se detectaron posibles riesgos de incumplimiento.", //检测到潜在合规风险
    SeachbuttonNo: "No se detectó ningún problema en esta empresa.", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Para buscar más registros de sanciones, haga clic en el botón "Buscar sanciones".', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Buscar sanciones", //搜索制裁
    ViewDetails: "Ver detalles", //查看详情
    Sanctions: "Sanciones", //制裁
    Potentialcompliancerisks: "Posibles riesgos de incumplimiento", //潜在合规风险
    IDInfo: "Información de ID", //ID 信息
    IDType: "Tipo de ID", //ID 类型
    IDDescription: "Descripción de ID", //ID 描述
    SanctionList: "Lista de sanciones", //制裁名单
    SanctionListInvolved: "Lista de sanciones involucradas", //涉及的制裁名单
    StartDate: "Fecha de inicio", //生效日期
    EndDate: "Fecha de finalización", //结束日期
    SourceList: "Lista de fuentes", //来源名单
    SourceName: "Nombre de la fuente", //来源名称
    ProfileNotes: "Notas del perfil", //主体资料
    Link: "Enlace", //链接
    Name: "Nombre", //名称
    AssociationList: "Lista de asociaciones",
    AssociationID: "ID de asociación",
    AssociationType: "Tipo de asociación",
  },
  CreditOpinion: {
    CreditAssessment: "Evaluación crediticia",
    CreditAssessmentfromtheRelatedCompanies:
      "Evaluación crediticia de las empresas relacionadas",
    Year: "Año",
    CreditRating: "Calificación crediticia",
    LocalCreditScore: "Puntuación crediticia local",
    ProbabilityofDefault: "Probabilidad de incumplimiento",
    SolvencyIndex: "Índice de solvencia",
    CreditLine: "Línea de crédito",
    RiskIndicator: "Indicador de riesgo",
    RelatedCreditAssessment: "Evaluación crediticia relacionada",
    CompanyName: "Nombre de la empresa",
    CompanyID: "ID de la empresa",
    Country: "País",
    CompanyStatus: "Estado de la empresa",
    Relations: "Relaciones",
    Cancel: "Cancelar", //取消
    Select: "Seleccionar",
    CreditAssessmentMessage1:
      "Cuando los datos del sujeto son insuficientes, o está interesado en obtener más información sobre su cliente, esta plataforma ofrece una vista integral de todas las entidades relacionadas con el tema. Esto incluye los accionistas de la empresa del sujeto, las empresas relacionadas y más.",
    CreditAssessmentMessage2:
      "Al brindarle una perspectiva más amplia, esta plataforma le permite realizar evaluaciones más informadas y obtener una comprensión más profunda de su tema.",
    LocalCreditRating: "Calificación crediticia local",
    LocalCreditRatingDetail:
      "Impulsado por el poder del big data, 3ARating es un sistema de calificación cuantitativa para empresas privadas. Es un esfuerzo de colaboración entre 3ACredit y Creditreform Rating. El modelo de calificación se construye sobre la base de una evaluación integral de varios factores clave, incluidos factores no financieros, factores financieros, registros negativos y consideraciones específicas de la industria. El modelo de calificación exhibe un impresionante coeficiente de Gini, lo que indica su solidez y confiabilidad. 3ARating abarca una variedad de clasificaciones, desde la clasificación más alta, 3A1, hasta la clase de clasificación más baja, 3A19.",
    CreditScore: "Puntaje de crédito",
    CreditScoreDetail:
      "Las puntuaciones crediticias se calculan en una escala del 1 al 100, según la calificación crediticia obtenida de las autoridades locales. Una puntuación más alta indica una mejor solvencia.",
    PossibilityofDefault: "Posibilidad de Incumplimiento (PD)",
    PossibilityofDefaultDetail:
      "La Posibilidad de Incumplimiento (PD) es una herramienta útil para la evaluación de riesgos, centrándose en la evaluación de la liquidez a corto plazo.",
    SolvencyIndexSI: "Índice de Solvencia (SI)",
    SolvencyIndexSIDetail:
      "El Índice de Solvencia (SI) es un indicador de alerta temprana altamente eficaz y fiable que permite una evaluación rápida de la solvencia de los socios comerciales. Un valor SI más alto indica un mayor riesgo de incumplimiento por parte de un cliente. El SI va desde 100, que se considera una calificación excelente, hasta 600, donde se presentan características muy negativas.",
    ExternalRating: "Calificación externa",
    DefaultProbability: "Probabilidad de incumplimiento (Pd1Año)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Seleccione el año para mostrar",
    SelectUptoThreeYears: "Seleccione hasta tres años",
    HighRisk: "Alto riesgo",
    Medium: "Medio",
    Moderate: "Moderada",
    Average: "Promedio",
    LowerThanAvg: "Inferior a la media",
    LowRisk: "Bajo riesgo",
    CreditOpinion: "Opinión crediticia",
  },
  IndustryStatistics: {
    SubjectCompany: "Empresa",
    Country: "País",
    Compare: "Comparar",
    Industry: "Sector",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamaño de la empresa",
    CompanyStatus: "Estado de la empresa",
    YearsinBusiness: "Años en el mercado",
    CompanyRating: "Calificación de la empresa",
    Liquidity: "Estado del flujo de caja",
    NoofcoinIndustry: "No. de co. en la industria",
    IndustryRating: "Calificación de la industria",
    Profitability: "Rentabilidad",
    Growth: "Crecimiento",
    FinancialStructurt: "Estructura financiera",
    Solvency: "Solvencia",
    SearchCountry: "Buscar país",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Análisis del sector",
    GeographicAnalysis: "Análisis geográfico",
    CompanyTypeAnalysis: "Análisis del tipo de empresa",
    BiusinessScaleAnalysis: "Análisis de la escala de negocio",
    HistoryAnalysis: "Análisis histórico",
    NormalDistribution: "Distribución normal",
    SubjectCompany: "Empresa del sujeto",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilidad de la calificación del sujeto en su sector",
    Maximum: "Máximo 10%",
    Mean: "Media",
    Average: "Promedio",
    Minimum: "Mínimo 10%",
    RatingDistribution: "Distribución de la calificación",
    Revenue: "Ingresos",
    Earning: "Ganancias",
    TotalAssets: "Activos totales",
    Subjectratinginitsindustrybyfinancialindicators:
      "Calificación del sujeto en su sector según indicadores financieros",
    Best: "Mejor",
    Worst: "Peor",
    Rankingofsubject:
      "Clasificación de la calificación del sujeto en el sector",
    Industy: "Sector",
    Percentilerank:
      "Percentil: % de empresas con una calificación igual o inferior a la del sujeto",
    Historicaldevelopmentofsubject:
      "Evolución histórica de la calificación del sujeto en su sector",
    IndustryAverage: "Promedio del sector",
    SubjectRatingChanges: "Cambios en la calificación del sujeto",
    CreditScore: "Puntaje de crédito",
    NOofCompanies: "No. de Empresas",
    ofCompanies: "% de empresas",
    CreditRating: "Calificación crediticia",
    CompanySize: "Tamaño de la empresa",
    YearsinBusiness: "Años en el mercado",
    SubjectsIndustryConcentrationAnalysis:
      "Análisis de concentración de la industria del sujeto",
    GeographicdistributionofSubjectsratingintsindustry:
      "Distribución geográfica de la calificación del sujeto en su industria",
    GeographicdistributioninSubjectindustry:
      "Distribución geográfica en la industria del sujeto",
    RatingDistributioninSubjectsLocation:
      "Distribución de calificaciones en la ubicación del sujeto",
    Ratinganalysisofcompanies:
      "Análisis de calificación de empresas de la misma industria con diferentes años de actividad",
    Subjectsratinghistory:
      "Historial de calificación del sujeto en comparación con sus pares con el mismo historial",
    Ratingrankingofcompanieswithsamehistory:
      "Ranking de calificación de empresas con la misma historia",
    Ratingstatistics:
      "Estadísticas de calificación de empresas con los mismos años de actividad",
    Subjectratingcomparing:
      "Calificación del sujeto en comparación con sus empresas pares con el",
    Subjectratinginitsgroup: "Calificación del sujeto en su grupo",
    Analysisbasedonnature:
      "Análisis basado en la naturaleza de las empresas en la industria del tema",
    Subjectratingpositioninitscompanytype:
      "Posición de calificación del sujeto en su tipo de empresa",
    Ratingstatisticsofcompanies:
      "Estadísticas de calificación de empresas de la misma industria",
    Ratinganalysisofcompanies:
      "Análisis de calificación de empresas de diferentes tamaños en la misma industria",
    Probabilityofsubjectrating:
      "Probabilidad de calificación del sujeto en su industria dentro de su tamaño",
    Subjectratingcomparingwithindustry:
      "Calificación del sujeto en comparación con sus pares en su industria:",
    RatingRankingofthecompanies:
      "Rating Ranking de empresas del mismo tamaño en el mismo sector",
    Ratingstatisticsofcompanies:
      "Estadísticas de calificación de empresas del mismo tamaño y del mismo sector",
    Rank: "Rango",
    Rating: "Calificación",
    CompanyType: "Tipo de empresa",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Posición en el mercado",
    Revenus: "Ingresos",
    NetEarnings: "Beneficio neto",
    NetAssets: "Activo neto",
    TotalAssets: "Activo total",
    Employees: "Empleados",
    Mean: "Media",
    Average: "Promedio",
    Maximum: "Máximo (10%)",
    Worst: "Peor (10%)",
    Subjectcompany: "Empresa en cuestión",
    PerformanceComparison: "Comparación de rendimiento",
    ProfitabilityRatios: "Ratios de rentabilidad",
    Grossmargin: "Margen bruto",
    Returnonassets: "Rendimiento sobre activos",
    Returnonequity: "Rendimiento sobre el capital",
    OperatingRatios: "Ratios operativos",
    Stockturnover: "Rotación de existencias",
    Assetsturnover: "Rotación de activos",
    Currentassetturnoverrate: "Tasa actual de rotación de activos",
    Collectionperiod: "Periodo de cobro",
    GrowthRatios: "Ratios de crecimiento",
    Totalassetsgrowthrate: "Tasa de crecimiento de los activos totales",
    Salesgrowthrate: "Tasa de crecimiento de las ventas",
    Netprofitgrowthrate: "Tasa de crecimiento del beneficio neto",
    StructuralRatios: "Ratios de estructura",
    Debtratio: "Ratio de endeudamiento",
    Quickratio: "ratio de liquidez inmediata",
    Currentratio: "Ratio de liquidez",
  },
  AccountCenterMenu: {
    SearchinSettings: "Buscar en Configuración", //在“设置”中搜索
    Account: "Cuenta", //账户
    MyAccount: "Mi cuenta", //我的账户
    ContactInfo: "Información de contacto", //联系信息
    AccountSecurity: "Seguridad de la cuenta", //账户安全
    OrganizationalManagement: "Gestión de la organización", //组织管理
    UserGroup: "Grupo de usuarios", //用户组
    User: "Usuario", //用户
    Role: "Rol", //角色
    MyDatabase: "Mi base de datos", //我的数据库
    MyUsage: "Mi uso", //我的使用情况
    CompaniesViewed: "Empresas consultadas", //查看过的公司
    ReportsDownloaded: "Informes descargados", //下载的报告
    ReportUpdatesOrdered: "Actualizaciones de informes solicitadas", //订购的报告更新
    BillingandPayment: "Facturación y pagos", //账单和付款
    BillRecords: "Registros de facturas", //账单记录
    PaymentRecords: "Registros de pagos", //付款记录
    CreditDeductions: "Deducciones de crédito", //信用扣款
    InvoicesDownloaded: "Facturas descargadas", //下载的发票
    UserSettings: "Configuración de usuario", //用户设置
    Messages: "Mensajes", //消息
    Notifications: "Notificaciones", //通知
    HelpCenter: "Centro de ayuda", //帮助中心
    FAQ: "Preguntas frecuentes", //常见问题
    Privacy: "Privacidad", //隐私
    Terms: "Términos", //条款
    ReportIssues: "Informar de problemas", //报告问题
    UserGuide: "Guía del usuario", //用户指南
    AboutCSI: "Acerca de CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Hora de inicio de sesión", //登录时间
    SignOut: "Cerrar sesión", //退出
    DeleteAccount: "Eliminar cuenta", //删除账户
    AccountID: "ID de la cuenta", //账户ID
    Enteranewaddress: "Ingresar una nueva dirección de correo electrónico", //输入新的电邮
    EnterVerificationCode: "Ingresar código de verificación", //输入验证码
    SendverificationCode: "Enviar código de verificación", //发送验证码
    Password: "Contraseña", //密码
    Originalpassword: "Contraseña original", //原始密码
    Newpassword: "Nueva contraseña", //新密码
    Confirmnewpassword: "Confirmar nueva contraseña", //确认新密码
    AccountOwnership: "Propiedad de la cuenta", //账户所有权
    IndividualAccount: "Cuenta individual", //个人账户
    GroupAccount: "Cuenta de grupo", //集团账户
    Organizationname: "Nombre de la organización", //机构名称
    CountryRegion: "País/Región", //国家/地区
    Address: "Dirección", //地址
    City: "Ciudad", //城市
    ZipCode: "Código postal", //邮政编码
    FirstName: "Nombre", //名字
    LastName: "Apellidos", //姓氏
    PhoneNumber: "Número de teléfono", //电话号码
    Email: "Correo electrónico", //更改
    Change: "Cambiar", //更改
    Save: "Guardar", //保存
    Cancel: "Cancelar", //取消
    LastLogin: "Último inicio de sesión", //Last Login
    RecentLogin: "Inicio de sesión reciente", //登录尝试次数
    AverageLoginTime: "Tiempo promedio de inicio de sesión", //平均登录时间
    TotalLoginAttempts: "Intentos totales de inicio de sesión", //登录尝试次数
    Registrationtime: "Tiempo de registro",
    Role: "Rol",
    Administrator: "Administrador",
    Enterpriseusers: "Usuarios empresariales",
    EditImage: "Editar imagen",
    DeleteImage: "Eliminar imagen",
  },
  ContactInfo: {
    ContactInfo: "Información de contacto",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    CountryRegion: "País/Región",
    AddressLine: "Dirección",
    City: "Ciudad",
    ZipCode: "Código postal",
    Alternativecontactperson: "Persona de contacto alternativa",
    Setascontactperson: "Establecer como persona de contacto",
    Edit: "Editar",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Configurar mis preguntas de seguridad",
    Pleasechooseaquestion: "Elige una pregunta",
    Pleaseentertheanswertothequestion: "Introduce la respuesta a la pregunta",
    SessionTimeoutAutomaticLogoutSettings:
      "Tiempo de espera de la sesión: Configuración de cierre de sesión automático",
    Thesystemwillautomatically:
      "El sistema cerrará tu sesión automáticamente tras un periodo de inactividad. El tiempo de espera predeterminado es de 5 minutos, pero puedes ajustarlo según tus necesidades.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Número total de empresas buscadas",
    TotalNumberofCompaniesCollected: "Número total de empresas recopiladas",
    TotalNumberofUpdateReportsOrdered:
      "Número total de informes de actualización solicitados",
    Date: "Fecha",
    UserName: "Nombre de usuario",
    CompanyName: "Nombre de la empresa",
    Status: "Estado",
    UsageType: "Tipo de uso",
    Entercompanyname: "Introduzca el nombre de la empresa",
    Download: "Descargar",
  },
  OrganizationalManagement: {
    GroupName: "Nombre del grupo",
    ParentGroupName: "Nombre del grupo principal",
    Organization: "Organización",
    GroupID: "ID del grupo",
    GroupStatus: "Estado del grupo",
    Operation: "Operación",
    NewlyBuilt: "Creado recientemente",
    UserAccount: "Cuenta de usuario",
    Role: "Rol",
    AccountStatus: "Estado de la cuenta",
    RoleName: "Nombre del rol",
    Position: "Posición",
    RoleStatus: "Estado del rol",
    Valid: "Válido",
    Invalid: "Inválido",
    PermissionSettings: "Configuración de permisos",
    ShowMore: "Mostrar más",
    Search: "Buscar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    NewGroup: "Nuevo grupo",
    EnterGroupName: "Introduzca el nombre del grupo",
    NumberofGroups: "Número de grupos",
    Groups: "Grupos",
    Roles: "Roles",
    NewRoles: "Nuevos roles",
    EnterNewRole: "Ingrese un nuevo rol",
    Users: "Usuarios",
    EnterUserName: "Introduzca el nombre de usuario",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Número total de pedidos",
    TotalPaymentAmount: "Importe total del pago",
    TotalUsedCredits: "Total de Créditos Utilizados",
    Date: "Fecha",
    UserAccount: "Cuenta de usuario",
    CompanyName: "Nombre de la empresa",
    OrderNo: "N.º de pedido",
    OrderType: "Tipo de pedido",
    OrderStatus: "Estado del pedido",
    Download: "Descargar",
    PaymentAmount: "Importe del pago",
    Contactus: "Contáctenos",
    DownloadInvoice: "Descargar factura",
    CreditUsage: "Uso del crédito",
    ReportOrderStatus: "Informar del estado del pedido",
    CompanyID: "ID de la empresa",
    CountryRegion: "País/Región",
    AddressLine: "Dirección",
    City: "Ciudad",
    ZipCode: "Código postal",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    BankAccountHolderName: "Nombre del titular de la cuenta bancaria",
    BeneficiaryBankName: "Nombre del banco beneficiario",
    SWIFTCODE: "CÓDIGO SWIFT",
    AccountNumber: "Número de cuenta",
    BeneficiaryBankAddress: "Dirección del banco beneficiario",
    ABA: "ABA (Número de ruta)",
    IBANnumber: "Número IBAN",
    StartingMonth: "Mes de inicio",
    EndMonth: "Fin de mes",
    InvoiceInfo: "Información de facturación",
  },
  UserSettings: {
    LanguageandLocation: "Idioma y ubicación",
    Language: "Idioma",
    Selectyourpreferedlanguage: "Seleccione su idioma preferido",
    Location: "Ubicación",
    Selectyourlocation: "Seleccione su ubicación",
    NotificationSetting: "Configuración de notificaciones",
    EmailNotification: "Notificaciones por correo electrónico",
    ServiceUpdates: "Actualizaciones del servicio",
    CompanyNews: "Noticias de la empresa",
  },
  AddCredit: {
    Customizeyourplan: "Personaliza tu plan como necesites",
    Silver: "Plata",
    Gold: "oro",
    Enterpris: "empresa",
    Credit: "Crédito",
    Remaining: "{0} puntos restantes",
    Usermonth: "usuario/mes",
    Useryear: "usuario/año",
    PaidMonthlyRenews:
      "Pagado mensualmente, sin necesidad de renovación automática",
    PaidAnnuallyRenews:
      "Pagado anualmente, sin necesidad de renovación automática",
    ForFullSupport: "para soporte completo a sus necesidades",
    Each: "cada uno",
    CreditsCharged:
      "Los créditos cargados a su cuenta nunca caducan mientras su cuenta permanezca activa.",
    PaidMonthly: "pagado mensualmente",
    PaidAnnually: "pagado anualmente",
    BuyNow: "comprar ahora",
    ContactNow: "contacta ahora",
    SearchCompanies:
      "Busque empresas y obtenga acceso instantáneo a los datos de la empresa que incluyen",
    EverythinginSilverPackage: "Todo en el paquete Silver, más",
    CreditsCanbeUsed:
      "Los créditos se pueden utilizar para más servicios de datos, incluidos los siguientes",
    UnlimitedAdvancedSearch: "Búsqueda avanzada ilimitada",
    ViewCompanyProfile: "Ver perfil de empresa",
    CompanyOwnershipStructure: "Estructura de propiedad de la empresa",
    CompanyFamilyTree: "árbol genealógico de la empresa",
    Companymanagement: "Gestión de la empresa",
    CompanyContactsinfo: "Información de contactos de la empresa",
    BusinessActivities: "Actividades empresariales",
    IndustryBasics: "Conceptos básicos de la industria",
    ImportExportRecords: "Registros de importación y exportación",
    CompanyPublications: "Publicaciones de la empresa",
    CompanyNews: "Noticias de la empresa",
    DownloadOnlineReport: "Descargar informe en línea",
    ManagementDetails: "Detalles de gestión",
    ShareholderPenetration: "Penetración accionarial (UBO)",
    Financialinfo: "Información financiera",
    FinancialAnalysis: "Análisis financiero",
    CreditAssessment: "Evaluación de crédito",
    IndustryAnalysis: "Análisis de la industria",
    MarketAnalysis: "Análisis de mercado",
    SupplyChaininfo: "Información de la cadena de suministro",
    CheckSanctions: "Consultar sanciones",
    CompanyComparison: "Comparación de empresas",
    DataExport: "Exportación de datos",
    MonitoringService: "Servicio de seguimiento",
    DiscountForFreshUpdateReports:
      "Descuento para informes de actualización nuevos",
    SearchCompany: "Buscar empresa",
    SearchLeads: "Búsqueda de clientes potenciales",
    SearchTrade: "Buscar comercio",
    SearchPeople: "buscar personas",
    SearchCountry: "Buscar país",
    SearchNews: "Buscar noticias",
    SearchSanction: "Sanción de búsqueda",
    DataServices: "Servicios de datos",
    APIPlans: "Planes API",
    VolumeDiscounts: "Descuentos por volumen",
    GroupAccountsWithMultipleUsers: "Cuentas de grupo con múltiples usuarios",
    CustomizedPlans: "Planes personalizados",
    FreshInvestigatedCreditReportsWorldwide:
      "Informes de crédito investigados recientemente en todo el mundo",
    BusinessMonitoringServices: "Servicios de seguimiento empresarial",
    BusinessProcessVerificationServices:
      "Servicios de verificación de procesos comerciales.",
    VendorComplianceReports: "Informes de cumplimiento de proveedores",
    MarketResearch: "investigación de mercado",
    More: "Más…",
    Contactus: "Contáctenos",
    PaymentMethod: "Método de pago",
    CreditCardNumber: "Número de tarjeta de crédito",
    EnterCardNumber: "Ingrese el número de tarjeta",
    ExpirationDate: "Fecha de vencimiento",
    Fullnameoncard: "Nombre completo en la tarjeta",
    EnterFullname: "Ingrese el nombre completo",
    EnterProvinceState: "Ingresar Provincia/Estado",
    CVCCode: "Código CVC",
    EnterCVCCode: "Ingrese el código CVC",
    TotalPurchase: "Compra Total",
    Agree1: 'Al hacer clic en "Enviar", acepta el ',
    Agree2: "Acuerdo de servicios y privacidad de CSI.",
    Submit: "Enviar",
    Month: "Mes",
    Year: "Año",
    Country: "País",
    ProvinceState: "Provincia/Estado",
    Cancel: "Cancelar",
    IncorrectCreditCardNumberformat:
      "Formato incorrecto del número de tarjeta de crédito",
    IncorrectExpMonthformat: "Formato de mes de vencimiento incorrecto",
    IncorrectExpYearformat: "Formato incorrecto del año de vencimiento",
    IncorrectFullNameformat: "Formato de nombre completo incorrecto",
    IncorrectCountryformat: "Formato de país incorrecto",
    IncorrectProvinceStateformat: "Formato incorrecto de provincia/estado",
    IncorrectCVCCodeformat: "Formato de código CVC incorrecto",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Qué tipo de errores reporta?",
    Tellusmoreaboutyourproblems: "Cuéntenos más sobre sus problemas.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Desea proporcionar una captura de pantalla o un archivo sobre su problema?",
    Fillinyourcontactinformation: "Complete su información de contacto",
    FirstName: "Nombre",
    LastName: "Apellidos",
    PhoneNumber: "Número de teléfono",
    Email: "Correo electrónico",
    Edit: "Editar",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " es su plataforma integral para obtener información completa sobre riesgos corporativos. Ofrecemos análisis detallados en todas las categorías de riesgo principales para proteger sus decisiones empresariales.",
    LegalRisk: "Riesgo legal",
    LegalRiskInfo: "Verificar la legitimidad de la empresa.",
    OrganizationalRisk: "Riesgo organizacional",
    OrganizationalRiskInfo:
      "Estabilidad de la gestión, complejidad de la estructura corporativa y transparencia de la propiedad.",
    OperationalRisk: "Riesgo operacional",
    OperationalRiskInfo:
      "Vulnerabilidades de la cadena de suministro, estado operacional y exposición geopolítica.",
    FinancialRisk: "Riesgo financiero",
    FinancialPerformanceRiskInfo:
      "tendencias de rentabilidad, problemas de liquidez y salud del balance general.",
    CreditRisk: "Riesgo de crédito",
    CreditRiskInfo: "solvencia, historial de pagos y probabilidad de impago.",
    ComplianceRisk: "Riesgo de incumplimiento",
    ComplianceRiskInfo:
      "Cumplimiento de las sanciones, las normas contra el blanqueo de capitales y las leyes específicas del sector.",
    SustainabilityRisk: "Riesgo de sostenibilidad",
    SustainabilityRiskInfo:
      "factores ESG (ambientales, sociales y de gobernanza) e impactos en la reputación.",
    IndustryRisk: "Riesgo sectorial",
    IndustryRiskInfo:
      "Evalúa la estabilidad y las perspectivas de todo el sector de una empresa.",
    LetBegin: "Comencemos",
    AddcompaniesfromSearchResult:
      "Agregar empresas de los resultados de búsqueda",
    AddcompaniesfromMyDatabase: "Agregar empresas de Mi base de datos",
    Addcompaniesbyuploadmyownlist: "Añadir empresas subiendo mi propia lista",
    Uploadyourlistofcompanies:
      "Sube tu lista de empresas y Risk Scan te proporcionará actualizaciones de datos instantáneas para cada entidad. Con evaluaciones de riesgo exhaustivas en ocho categorías, Risk Scan transforma tu gestión de riesgos, pasando de un enfoque reactivo a una ventaja estratégica proactiva.",
    Select: "Seleccionar",
    Upload: "Subir",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    UploadFiles: "Téléverser des fichiers",
    PleaseuploadyourfileinCVSformat:
      "Veuillez téléverser votre fichier au format xlsx.",
    Downloadxlsxtemplate: "Télécharger le modèle xlsx",
    Xcompanieswereuploadedsucessfuly:
      "Las empresas {0} se cargaron correctamente.",
    Xcompanieswereidentifiedsucessfuly:
      "Se identificaron con éxito {0} empresas.",
    Xcompanieswerenotmatched: "{0} empresas no coincidieron.",
    Uploadingfilefailed:
      "No se pudo cargar el archivo. Utilice la plantilla e inténtelo de nuevo.",
    Uploading: "Subiendo",
    Uploadwithamaximumfilesizeof1M:
      "(Se pueden cargar un máximo de 100 entradas de datos a la vez, con un tamaño máximo de archivo de 1 MB).",
    Tryagain: "Intentar otra vez",
    Theuploadedonlyxlsx:
      "El archivo subido solo puede estar en formato xls/xlsx",
    Scanning: "Exploración",
    RiskScanning: "Análisis de riesgos",
    Youhaveselectedatotalof: "Has seleccionado",
    Tostartriskscanning:
      'empresas. Haz clic en "Confirmar" para comenzar el escaneo.',
    Datascanningisinprogress: "El escaneo de datos está en curso...",
    LastUpdate: "Última actualización",
    Selectdate: "Seleccione la fecha",
    UpdateStatus: "Estado de actualización",
    ClearAll: "Borrar todo",
    ALL: "Todos",
    Updated: "Actualizada",
    Notupdated: "No actualizado",
    HistoricalData: "Datos históricos",
    Selectrisklevel: "Seleccione el nivel de riesgo",
    Low: "Bajo",
    Average: "Promedio",
    Caution: "Precaución",
    NotRated: "No clasificada",
    Reselect: "Volver a seleccionar",
    HistoricalRecords: "Registros históricos",
    DownloadReport: "Descargar informe",
    SearchLeads: "Prospectos de búsqueda",
    CompanyName: "Nombre de empresa",
    CompanyID: "ID de la empresa",
    CompanyType: "Tipo de empresa",
    RegistrationDate: "Fecha de registro",
    RegistrationStatus: "Estado de registro",
    Listed: "cotiza en la bolsa de valores",
    LegalStatus: "Estatus legal",
    NoofShareholders: "Número de accionistas",
    ShareholdingLayers: "niveles de accionistas",
    NoofCorporateShareholders: "Número de accionistas corporativos",
    NoofNatualPersonShareholders: "Número de accionistas personas físicas",
    RelatedCompanies: "Empresas relacionadas",
    OrganizationalStatus: "Estado organizativo",
    OperatingAddress: "Dirección de funcionamiento",
    IndustryCode: "Código de la industria",
    BusinessActivities: "Actividades de negocio",
    NoofEmployees: "Número de empleados",
    Management: "Gestión",
    CurrentOperations: "Operaciones actuales",
    Revenue: "volumen de negocios",
    Assests: "Activos",
    ProfitLoss: "Ganancias/Pérdidas",
    Liquidity: "Liquidez",
    Growth: "crecimiento",
    Performance: "rendimiento operativo",
    CreditRating: "clasificación crediticia",
    CreditScore: "Puntuación de crédito",
    PausibilityofDefault: "Pausa por defecto (PD)",
    SolvencyIndex: "Índice de solvencia",
    DebtCollection: "cobro de deudas",
    CreditOpinion: "Opinión crediticia",
    CompanySanction: "de sanciones corporativas",
    ProductSanction: "Sanción del producto",
    ExportControl: "Control de exportaciones",
    AntiCorruptionAntiBribery: "Anticorrupción y antisoborno",
    Litigations: "Litigios",
    NegativeNews: "Noticias negativas",
    ESGScore: "Puntuación ESG",
    YearsinBusiness: "Años en el negocio",
    Competitiveness: "Competitividad",
    WorkingCapital: "Riesgo de mercado",
    FinancialStructure: "Índice de la cadena de suministro",
    Industrystatus: "Situación de la industria",
    IndustryOutlook: "Perspectivas del sector",
    NoofCompanies: "Número de empresas",
    IndustryRanking: "Clasificación del sector",
    IndustryConcentration: "% del PIB del sector",
    IndustryCompetitiveness: "Competitividad de la industria",
    IndustryDevelopment: "Desarrollo de la industria",
    Legal: "Legal",
    Organizational: "Organizativa",
    Operational: "Operacional",
    Financial: "Financiera",
    Credit: "Crédito",
    Compliance: "Cumplimiento",
    Sustainability: "Sostenibilidad",
    Industry: "Industria",
    ScanDate: "Fecha de escaneo",
    Updating: "Actualizando",
    ScanHistoricalData: "Escanee los datos históricos",
    StartDate: "Fecha de inicio",
    EndDate: "Fecha de finalización",
    Download: "Descargar",
    Entercompanyname: "Ingresar nombre de la empresa",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestión de datos",
    AllCompanies: "Todas las empresas",
    CompaniesViewed: "Empresas vistas",
    CompaniesCollected: "Empresas recogidas",
    CompaniesUploaded: "Empresas cargadas",
    MyPortfolio: "Mi portafolio",
    Date: "Fecha",
    CompanyName: "Nombre de empresa",
    Country: "País",
    CompanyType: "Tipo de empresa",
    CompanyStatus: "Estado de la empresa",
    DQI: "DQI",
    Download: "Descargar",
    Addcompanies: "Agregar empresas",
    Filter: "Filtrar",
    Selectcountry: "Seleccionar país",
    Selectindustry: "Seleccionar industria",
    Selectcompanytype: "Seleccione el tipo de empresa",
    Selectcompanysize: "Seleccione el tamaño de la empresa",
    Selectcompanystatus: "Seleccionar el estado de la empresa",
    Selectlistedcompanies: "Seleccionar empresas cotizadas",
    Selectcompanyyearsinbusiness:
      "Seleccione los años de actividad de la empresa",
    Industry: "Industria",
    CompanySize: "Tamaño de la empresa",
    Listed: "cotizan en bolsa",
    CompanyAge: "Edad de la empresa",
    SelectYear: "Seleccione año",
    SelectQuarter: "Seleccionar trimestre",
    SelectMonth: "Seleccionar mes",
    Reset: "Reiniciar",
    Search: "Buscar",
    MyDatabase: "Mi base de datos",
    Locations: "Ubicaciones",
    YearsinBusiness: "Años en el negocio",
    CompanyDQI: "DQI",
    RiskScan: "Análisis de riesgos",
    CreditAssessment: "Evaluación de crédito",
    Uptodate: "A hoy",
    Average: "Promedio",
    Insufficient: "Insuficiente",
    Good: "Buena",
    Caution: "Precaución",
    Unknown: "Precaución",
    CompanyTag: "Etiqueta de la empresa",
    Remove: "Eliminar",
    Uploaded: "Subido",
    Identified: "Identificada",
    Notmatched: "No coincidente",
    UploadCompanies: "Subir empresas",
    Match: "Fósforo",
    Delete: "Borrar",
    OnlineMatching: "Emparejamiento en línea",
    Identifythecompanywithmanualcheck:
      "Identificar la empresa con verificación manual",
    Identifyacompanymanually: "Identificar una empresa manualmente",
    Pleaseprovideanyrelevantinformation:
      "Proporcione cualquier información relevante que pueda mejorar los resultados de la búsqueda. Nuestro analista de datos le asignará la empresa más adecuada.",
    RegistrationID: "ID de empresa",
    StateProvince: "Estado/Provincia",
    Address: "direccion",
    Otherinformation: "Otra información",
    Submit: "Entregar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    EnterRegistrationID: "Ingrese el número de registro",
    EnterAddress: "Ingrese la dirección",
    EnterInformation: "Ingrese la información",
    User: "Usuaria",
    Task: "Tarea",
    NoofCompanies: "Número de empresas",
    Entercompanyname: "Introduzca el nombre de la empresa",
    SaveYourPortfolio: "Guarde su cartera",
    PortfolioName: "Nombre de Portolio",
    Notes: "Notas",
    Edit: "Editar",
    EnterPortfolioName: "Ingrese el nombre del portafolio",
    EnterUserName: "Introduzca el usuario",
    SelectTaskName: "Seleccione la tarea",
    EnterNotes: "Introduzca las notas",
    StartingMonth: "Mes de inicio",
    EndMonth: "Fin de mes",
  },
  Relationship: {
    SearchRelationship: "Relación de búsqueda",
    SearchRelationshipInfo:
      " es nuestro servicio de datos líder, diseñado para iluminar el ecosistema corporativo completo de cualquier empresa. La plataforma ofrece una visión integral de 360 ​​grados de la empresa analizada, revelando:",
    UltimateOwnershipControl: "Propiedad y control definitivos",
    UltimateOwnershipControlInfo:
      "Descubra la cadena de propiedad rastreando a través de capas complejas para identificar a los beneficiarios finales y a todos los accionistas.",
    InvestmentParticipation: "Inversión y participación",
    InvestmentParticipationInfo:
      "Descubra todas las empresas en las que la empresa ha invertido, con las que se ha asociado o en las que ha participado, revelando direcciones estratégicas y alianzas ocultas.",
    SupplyChainNetwork: "Red de la cadena de suministro",
    SupplyChainNetworkInfo:
      "Mapee el espectro de relaciones comerciales, identificando a todos los posibles proveedores y clientes para comprender el flujo comercial completo.",
    Ourplatformempowers:
      "Nuestra plataforma potencia sus decisiones críticas al ayudarle a descubrir oportunidades, optimizar el cumplimiento normativo y mitigar riesgos. Con Search Relationship, la transparencia está a solo una búsqueda de distancia.",
    LetsBegin: "Comencemos",
    CompanyName: "Nombre de empresa",
    Country: "país",
    Industry: "Industria",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamaño de la empresa",
    CompanyStatus: "Estado de la empresa",
    ListingInfo: "Información de cotización",
    YearsinBusiness: "Años de funcionamiento",
    IncDate: "Fecha de constitución",
    HSCode: "Código HS",
    Product: "Producto",
    HsCodeProduct: "Código HS / Producto",
    ImportExport: "Importación y exportación",
    Entercompanyname: "Introduzca el nombre de la empresa",
    SelectHsCodeProduct: "Seleccione el código HS / Producto",
    Background: "Antecedentes",
    CompanySnapshot: "Resumen de la empresa",
    Address: "direccion",
    CountyCity: "Condado/Ciudad",
    ProvinceState: "Provincia/Estado",
    CountryRegion: "País/Región",
    ZipCode: "Código postal",
    RegName: "Nombre registrado",
    Website: "Sitio web",
    Email: "Correo electrónico",
    Phone: "Teléfono",
    LastUpdate: "Última actualización",
    DataSource: "Fuente de datos",
    CompanyProfile: "Perfil de la empresa",
    CoNativeName: "Nombre nativo de la empresa",
    CompanyID: "ID de empresa",
    VATNumber: "Número de IVA",
    StockExchangeNumber: "Número de la Bolsa de Valores",
    Listed: "Registrado",
    RegistrationDate: "Fecha de registro",
    LegalForm: "Forma jurídica",
    LegalStatus: "Estatus legal",
    Jurisdiction: "Jurisdicción",
    RegisteredAddress: "Dirección registrada",
    OperatingAddress: "Dirección de funcionamiento",
    Ownership: "Propiedad",
    Investments: "Inversiones",
    PossibleVendors: "Posibles proveedores",
    PossibleClients: "Posibles clientes",
    UItimateBeneficiaryOwner: "Beneficiario Final (UBO)",
    ControllingShareholder: "Accionista mayoritario",
    Participations: "Participaciones",
    ShareholderLevel: "Capas de participación accionaria",
    PartiesInvolved: "Partes involucradas",
    RelatedCompanies: "Empresas relacionadas",
    CompanyShareholders: "Accionistas de la empresa",
    CoShareholders: "Accionistas de la empresa",
    NGOShareholders: "Accionistas de ONG",
    NaturalPersonShareholders: "Accionista Persona Física",
    SubjectsInvestments: "Inversiones del sujeto",
    CorporateShareholders: "Accionistas corporativos",
    Name: "Nombre",
    Location: "Ubicación",
    Type: "Tipo",
    Shares: "Acciones (%)",
    Relations: "Relaciones",
    TotalEntities: "Entidades totales",
    Entities: "Entidades",
    Subsidiaries: "Filiales",
    Countries: "Países",
    Branches: "Sucursales",
    Relationship: "Relación",
    RelationType: "Tipo de relación",
    RelationLevel: "Nivel de relación",
    Management: "Direccion",
    ContactInfo: "Información de contacto",
    Position: "Puesto",
    Department: "Departamento",
    ShareholderorNot: "Accionista o no",
    Pleaseentername: "Por favor ingrese el nombre",
    SupplyChain: "Cadena de suministro",
    PossibleClients: "Posibles clientas",
    PossibleSuppliers: "Posibles proveedores",
    Banking: "Bancaria",
    TotalSales: "Ventas totales",
    TotalPurchasing: "Compras totales",
    ActivePlayers: "Jugadoras activas",
    MainProductsServices: "Principales productos/servicios",
    TotalTradingVolume: "Volumen total de negociación",
    TransactionTotal: "Transacción/Total (%)",
    RecentTradeDate: "Fecha de la última transacción",
    IndustryCode: "Código de industria",
    TradeRelatedCompanies: "Empresas relacionadas",
    TradeRelatedProductTOP10: "Productos relacionados (TOP 10)",
    UBO: "Beneficiario final",
    Numberofshareholderenterprises: "Número de accionistas",
    CurrentLevel: "Nivel actual",
    SharesonSubjectCo: "Acciones de la empresa en cuestión.",
    EnterCurrentLevel: "Ingresa tu nivel actual",
    EnterCountry: "Ingresa tu país",
    DirectShareholdingPercentage: "Porcentaje de participación directa",
    TotalOwnershipPercentage: "Porcentaje de participación total",
    InvestmentHoldingLevel: "Nivel de tenencia de la inversión",
  },
  SearchSanctions: {
    CountryISO: "País ISO",
    Currency: "Moneda",
    Language: "Idioma",
    SanctionOtherCountries: "Sancionar a otros países",
    SanctionedbyOtherCountries: "Sancionado por otros países",
    CountriesTerritories: "Países/Territorios",
    Selectcountryterritory: "Seleccionar país/territorio",
    Noofcountriessanctionedby: "Nº de países sancionados por {0}",
    Noofcountriesthatsanctioned: "No. de países que sancionaron a {0}",
    Noofsanctionedcompanies: "Nº de empresas sancionadas",
    Noofsanctionedpersonnel: "Nº de personal sancionado",
    SanctionOverview: "Resumen de sanciones",
    NoofSanctions: "No. de Sanciones",
    TypesofSanctions: "Tipos de sanciones",
    SourceofSanctions: "Fuente de sanciones",
    Details: "Detalles",
    Advisories: "Avisos",
    LawEnforcement: "Aplicación de la ley",
    Warnings: "Advertencias",
    FinancialSanctions: "Sanciones financieras",
    ExclusionList: "Lista de exclusión",
    TradeRestrictions: "Restricciones comerciales",
    VisaTravelBan: "Prohibición de visados/viajes",
    WarCrimes: "Crímenes de guerra",
    EnforcementOrders: "Órdenes de ejecución",
    Others: "Otros",
    ClearAll: "Borrar todo",
    Provider: "Proveedor",
    Description: "Descripción",
    Sanctions: "Sanciones",
    SanctionID: "ID de sanción",
    SelectsanctionID: "Seleccionar ID de sanción",
    SanctionedType: "Tipo sancionado",
    SelectSanctionedType: "Seleccionar tipo de sanción",
    CompanyPersonnel: "Empresa/Personal",
    Selectcompanypersonnel: "Seleccionar empresa/personal",
    SanctionCategory: "Categoría de sanción",
    Selectsanctioncategory: "Seleccionar categoría de sanción",
    Reference: "Referencia",
    Selectreference: "Seleccionar referencia",
    SanctionSource: "Fuente de sanción",
    Selectsanctionsource: "Seleccionar fuente de sanción",
    Status: "Estado",
    Selectstatus: "Seleccionar estado",
    CountryofSource: "País de origen",
    Name: "Nombre",
    SanctionedCountries: "Países sancionados",
    ProviderCode: "Código de proveedor",
    RecordSource: "Fuente de registro",
    From: "Desde",
    To: "Hasta",
    CompanyName: "Nombre de la empresa",
    SelectCompanyName: "Seleccione el nombre de la empresa",
    Country: "País",
    SelectCountry: "Seleccionar país",
    SelectRecordSource: "Seleccione la fuente del registro",
    RegName: "Nombre registrado",
    Address: "Dirección",
    Website: "Sitio web",
    CountyCity: "Condado/Ciudad",
    Email: "Correo Electrónico",
    ProvinceState: "Provincia/Estado",
    Tel: "Teléfono",
    CountryRegion: "País/Región",
    LastUpdate: "Última Actualización",
    ZipCode: "Código Postal",
    DataSource: "Fuente de Datos",
    SanctionInfo: "Información de sanción",
    SanctionRelated: "Relacionado con la sanción",
    OwnershipRelatedCompanies: "Propiedad y empresas relacionadas",
    OfficialSanctionList: "Lista oficial de sanciones",
    SanctionType: "Tipo de sanción",
    Type: "Tipo",
    Relations: "Relaciones",
    ProfileNotes: "Notas del perfil",
    Sources: "Fuentes",
    DescriptionofReferenceName: "Descripción de la referencia Nombre",
    DOB: "fecha de nacimiento",
    Gender: "Género",
    SearchPersonName: "Buscar por nombre de persona",
    SelectDOB: "Seleccionar fecha de nacimiento",
    Male: "Masculino",
    Female: "Femenino",
    All: "Todos",
    FirstName: "Nombre",
    MiddleName: "Segundo nombre",
    LastName: "Apellido",
    PreviousName: "Nombre anterior",
    PlaceofBirth: "Lugar de nacimiento",
    Citizenship: "ciudadanía",
    Residence: "Residencia",
    Juristiction: "Jurisdicción",
    History: "Historia",
    Category: "categoría",
    Title: "Título",
    SanctionRecord: "Registro de sanciones",
    Relationship: "Relación",
    HSCode: "Código HS",
    ProductName: "Nombre del producto",
    SanctionedCountryRegion: "País/región sancionados",
    SelectSanctionedCountryRegion: "Seleccione el país/región sancionado",
    SelectHSCode: "Seleccione el código HS",
    SelectProductName: "Seleccione el nombre del producto",
    Selectsanctiontype: "Seleccione el tipo de sanción",
  },
  SearchTrade: {
    LastUpdate: "Última actualización",
    ProductCode: "Código de producto",
    ProductDescription: "Descripción del producto",
    Sanctions: "Sanciones",
    TotalImports: "Importaciones totales",
    TotalExports: "Exportaciones Totales",
    TotalImportWeight: "Peso total de importación",
    TotalExportWeight: "Peso total de exportación",
    NumberofSuppliers: "Número de proveedores",
    NumberofBuyers: "Número de compradores",
    NumberofOriginCountries: "Número de países de origen",
    NumberofDestinationCountries: "Número de países de destino",
    TradeMap: "Mapa comercial",
    Imports: "Importaciones",
    Exports: "Exportaciones",
    Reset: "Reiniciar",
    Product: "Producto",
    Destination: "Destino",
    Origin: "Origen",
    NoData: "Sin datos",
    Date: "Fecha",
    TotalTransactions: "Transacciones totales",
    Transactions: "Transacciones",
    TradeRanking: "Clasificación comercial",
    Top5Ranking: "Los 5 primeros puestos del ranking",
    Growth: "Crecimiento",
    Decline: "Declive",
    TradeTrends: "Tendencias comerciales",
    TradeVolume: "Volumen comercial",
    MonthonMonthRatio: "Ratio mes a mes",
    Suppliers: "Proveedores",
    Buyers: "Compradores",
    Startdate: "Fecha de inicio",
    Enddate: "Fecha de fin",
    SelectCountry: "Seleccione un país",
    SelectCompany: "Seleccione una empresa",
    ClearAll: "Borrar todo",
    TransactionDate: "Fecha de la transacción",
    SelectTransactionDate: "Seleccione la fecha de la transacción",
    Company: "Empresa",
    CompanyName: "Nombre de empresa",
    Country: "País",
    Industry: "Sector",
    SelectIndustry: "Seleccionar industria",
    SupplierOverview: "Resumen del proveedor",
    BuyerOverview: "Resumen del comprador",
    CompanyID: "ID de la empresa",
    ISIC: "Código ISIC",
    ISICDescription: "Descripción del código ISIC",
    TotalTradeAnnual: "Comercio total (anual)",
    TotalTradePastsixmonth: "Comercio total (últimos 6 meses)",
    ContactInformation: "Información del contacto",
    ShippingOverview: "Información general sobre el transporte marítimo",
    TradeHistoryandTrends: "Historial y tendencias del comercio",
    SupplyChainList: "Lista de la cadena de suministro",
    RegistrationDate: "Fecha de Registro",
    Profit: "Beneficios",
    NoofShareholders: "N.° de Accionistas",
    TotalAssets: "Activo total",
    IndustryCode: "Código de Sector",
    CreditRating: "Calificación Crediticia",
    NoofEmployees: "N.º de empleados",
    CreditScore: "Puntuación Crediticia",
    Listed: "Cotizada",
    ESGRating: "Calificación ESG",
    Revenue: "Ingresos",
    DQI: "DQI",
    MoreCoDetails: "Más detalles de la empresa",
    CoNews: "Noticias de la empresa",
    MoreCoNews: "Más noticias de la empresa",
    IndustryMean: "Media del sector",
    TargetSubjectRevenue: "Ingresos del sector objetivo",
    PossibleBuyers: "Posibles compradores",
    PossibleSuppliers: "Posibles proveedores",
    ShowAll: "Mostrar todo",
    TotalExportsAnnual: "‌Exportaciones Totales (Anuales)‌",
    TotalImportsAnnual: "‌Importaciones Totales (Anuales)‌",
    ExportAmount: "‌Monto De Las Exportaciones‌",
    ImportAmount: "‌Monto De Las Importaciones‌",
    ShipmentDetail: "‌Detalles Del Envío‌",
    Entersuppliername: "‌Ingrese El Nombre Del Proveedor‌",
    Enterbuyername: "‌Ingrese El Nombre Del Comprador‌",
    SupplierName: "‌Nombre Del Proveedor‌",
    BuyerName: "‌Nombre Del Comprador‌",
    TotalAmount: "‌Monto Total‌",
    Details: "‌Detalles‌",
    WaybillDetails: "Detalles de la guía de remisión",
    ListofOrigins: "‌Lista De Origenes‌",
    ListofDestinations: "‌Lista De Destinos‌",
    ISO: "‌ISO‌",
    Currency: "‌Moneda‌",
    Language: "Idioma",
    Address: "‌Dirección‌",
    OverviewofSupplyChainInformation:
      "Resumen de la información de la cadena de suministro",
    OriginInformationOverview: "Resumen de la información de origen",
    DestinationInformationOverview: "Resumen de la información de destino",
    ImportCountries: "Países de importación",
    ExportCountries: "Países de exportación",
    ImportCompanyTop: "Empresa importadora número 1",
    ExportCompanyTop: "Empresa exportadora número 1",
    SanctionType: "‌Tipo de sanción‌",
    SelectSanctionType: "‌Seleccionar tipo de sanción‌",
    SanctionedCountryRegion: "‌País/Región sancionado(a)‌",
    SelectSanctionedCountryRegion: "‌Seleccionar país/Región sancionado(a)‌",
    HSCode: "‌Código SH‌",
    SanctionedProductsOverview: "‌Resumen de productos sancionados‌",
    Searchmoresanctiononothercompanies:
      "‌Buscar más sanciones en otras empresas‌",
    SimilarProducts: "Productos similares",
    Numberofsimilarproducts: "Número de productos similares",
    TopImportCountries: "Los 5 principales países importadores",
    TopExportCountries: "Los 5 principales países exportadores",
    PleaseSelect: "Seleccione",
    EnterHSCodeProductName: "Ingrese el código HS y el nombre del producto",
    ImportProducts: "Productos de importación",
    ExportProducts: "Productos de exportación",
    NumberofOrigin: "Número de países de origen",
    NumberofDestination: "Número de países de destino",
    NumberofImportProducts: "Número de productos importados",
    NumberofExportProducts: "Número de productos exportados",
    ProductName: "Nombre del producto",
    SelectProductName: "Seleccione el nombre del producto",
    TopExportProducts: "Los 5 productos más exportados",
    TopImportProducts: "Los 5 productos más importados",
    ExportProductOverview: "Panorama general de los productos de exportación",
    ImportProductOverview: "Panorama general de los productos de importación",
    CompanyCompetitiveness: "Competitividad de la empresa",
    GlobalMarketShare: "Cuota de mercado global",
    RegionalMarketShare: "Cuota de mercado regional",
    BusinessGrowthGlobalMarket: "Crecimiento empresarial (mercado global)",
    BusinessGrowthRegionalMarket: "Crecimiento empresarial (mercado regional)",
    CreditAssessment: "Evaluación crediticia",
    LocalCreditScore: "Puntaje de crédito local",
    SolvencyIndex: "Índice de solvencia",
    ProbabilityofDefault: "Probabilidad de incumplimiento",
    RiskIndicator: "Indicador de riesgo",
    CreditLine: "Línea de crédito",
    ReturnonEquity: "Rentabilidad sobre el capital",
    ProfitMargin: "Margen de beneficio",
    RelatedCreditAssessment: "Evaluación crediticia relacionada",
    HighRisk: "Riesgo alto",
    Medium: "Riesgo medio",
    Moderate: "Riesgo moderado",
    Average: "Riesgo promedio",
    LowerThanAvg: "Riesgo inferior al promedio",
    LowRisk: "Riesgo bajo",
    CreditOpinion: "Opinión crediticia",
    ComparisonofSimilarProducts: "Comparación de productos similares",
    AddProduct: "Agregar producto",
  },

  TradeByCountry: {
    // ImpExpCountries: "",
    // ImpExpCompanies: "",
    // ImpExpProducts: "",
    // Assessment: "",
    TotalImportAmount: "Importe total de las importaciones",
    GlobalImportShare: "Participación mundial de las importaciones",
    ImportGrowth: "Crecimiento de las importaciones",
    TotalExportAmount: "Importe total de las exportaciones",
    GlobalExportShare: "Participación mundial de las exportaciones",
    ExportGrowth: "Crecimiento de las exportaciones",
    TradeBalance: "Banca comercial",
    CountryData: "Datos por país",
    GDP: "PIB",
    GDPPPP: "PIB (PPA)",
    ExportsofGoods: "Exportaciones de bienes",
    ExportsofServices: "Exportaciones de servicios",
    ImportsofGoods: "Importaciones de bienes",
    ImportsofServices: "Importaciones de servicios",
    CPI: "IPC",
    Population: "Población",
    ContainerPortThroughput: "Torneo de contenedores en puerto",
    DistributionofImportExportCountries:
      "Distribución de países importadores y exportadores",

    Top5Ranking: "Los 5 principales países",
    Importers: "Importadores",
    Exporters: "Exportadores",
    ImportCountries: "Países importadores",
    ExportCountries: "Países exportadores",
    ImportProducts: "Productos importados",
    ExportProducts: "Productos exportados",
    CountryImportExportOverview:
      "Resumen de importaciones y exportaciones por país",
    Year: "Año",
    Amount: "Importe",
    Balance: "Saldo",
    CountryTradeDataComparison: "Comparación de datos comerciales entre países",
    Comparison: "Comparación",
    AddSample: "Añadir muestra",
    AddCriteria: "Añadir criterios",
    ImportCountry: "País de importación",
    Selectimportcountries: "Seleccionar países de importación",
    ExportCountry: "País de exportación",
    Selectexportcountries: "Seleccione los países de exportación",
    EnterHSCodeProductName: "Ingrese el nombre del producto o el código HS",
    // Afterselectingthecriteria: "",
    ShowResult: "Mostrar resultado",
    ListofTradeCompanies: "Lista de empresas comerciales",
    TotalCompanies: "Empresas totales",
    Top5Products: "Los 5 mejores productos",
    ListofExportProducts: "Lista de productos de exportación",
    ListofImportProducts: "Lista de productos de importación",
    Top5ExportCountries: "Los 5 principales países exportadores",
    Top5ImportCountries: "Los 5 principales países importadores",
    HSDescription: "Descripción SA",
    HSCode: "‌Código SH‌",
    TradeCompetitivenessIndex: "Índice de Competitividad Comercial",
    TotalTradeAmount: "Monto Total del Comercio",
    NetTradeBalance: "Banca Comercial Neta",
    TradeGap: "Déficit Comercial",
    TradeGoodsExports: "Exportaciones de Bienes",
    TradeGoodsImports: "Importaciones de Bienes",
    TradeServicesExports: "Exportaciones de Servicios",
    TradeServicesImports: "Importaciones de Servicios",
    CompositePMI: "Índice PMI Compuesto",
    ServicesPMI: "Índice PMI de Servicios",
    LegalEnvironment: "Entorno Jurídico",
    CorporateTaxRate: "Tasa del Impuesto de Sociedades",
    PersonalIncomeTaxRate:
      "Tasa del Impuesto sobre la Renta de las Personas Físicas",
    SalesTaxRate: "Tasa del Impuesto sobre las Ventas",
    BusinessConfidenceIndex: "Índice de Confianza Empresarial",
    CountryRating: "Clasificación por País",
    CompetitivenessIndex: "Índice de Competitividad",
    CompetitivenessRank: "Ranking de Competitividad",
    EaseofDoingBusiness: "Facilidad para Hacer Negocios",
    BusinessConfidence: "Confianza Empresarial",
    ConsumerConfidence: "Confianza del Consumidor",
    BusinessClimateAssessment: "Evaluación del clima empresarial",
    SP: "S&P",
    Moodys: "Moody's",
    Fitch: "Fitch",
    DBRS: "DBRS",
    Allianz: "Allianz",
    Coface: "Coface",
    Atradius: "Atradius",
    OECD: "OCDE",
    Productivecapacitiesindex: "Índice de capacidad productiva",
    PleaseSelect: "Seleccione",
    transactionvolume: "Volumen de transacciones",
    Growth: "Crecimiento",
    Decline: "Declive",
    SelectCountry: "Seleccionar país",
    TradeVolume: "Volumen comercial",
    Youcanonlyaddupto5datacomparisonitems:
      "Solo puede agregar hasta 5 elementos de comparación de datos",
    // DataComparisonActive: "",
    // DataComparisonBlack: "",
    ProductName: "Nombre del producto",
    Product: "Producto",
    EnterproductnameorHSCode: "Ingrese el nombre del producto o el código HS",
    Date: "Fecha",
    OverviewofAnalysisContent: "Descripción general del contenido del análisis",
    Afterselectingthecriteria: "Tras seleccionar los criterios, ",
    thecomparisonresultwillbedisplayed:
      "se mostrará el resultado de la comparación.",

    ImportExport: "Importación y exportación",
    All: "Todos",
    Company: "Compañía",
    SelectCompanyName: "Seleccione el nombre de la empresa",
    SelectProductName: "Seleccione el nombre del producto",

    CompanyID: "ID de la empresa",
    CO: " C/O",
    ISIC: "Código ISIC",
    ISICDescription: "Descripción del código ISIC",
    Top5ExportProducts: "Los 5 productos más importados",
    Top5ImportProducts: "Los 5 productos más exportados",
    ContactInformation: "Información del contacto",
    SearchTrade: "Buscar comercio",
    NumberofImportProducts: "Número de productos importados",
    NumberofExportProducts: "Número de productos exportados",
    TransactionYear: "Año de la transacción",
    SelectTransactionYear: "Seleccionar año de la transacción",
    Totalnumberofimportedproducts: "Número total de productos importados",
    Totalnumberofexportedproducts: "Número total de productos exportados",
    Updateyear: "Año de actualización",
    // TotalTrade: "",
    ISO: "ISO",
    Currency: "Moneda",
    Language: "Idioma",
  },
  ...esLocale,
};

export default es;
